module.exports = __webpack_public_path__ + "img/6f_r_tokiwa@2x.e778f712.png";